import { useRef } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { useCallback } from "react";
import { useState } from "react";
import { createContext } from "react";
import { useSelector } from "react-redux";
import GlobalContext from "../framework/GlobalContext";
import { focusCell } from "../utils/gridUtils";

const StockAuditContext = createContext();

export const StockAuditContextProvider = ({ children }) => {
  const medicineGridRef = useRef();
  const saveRef = useRef();
  const [saveAudit, setSaveAudit] = useState(false);
  const [showAuditorDetails, setShowAuditorDetails] = useState(false);
  const { autocompleteOpen, currentComponent, focusLastRow, setFocusLastRow } =
    useContext(GlobalContext);
  const { currentFocus } = useSelector(
    (state) => state.commonReducer.tabs[state.commonReducer.activeTabIndex]
  );
  const default_focus = medicineGridRef;

  const stockAuditContextListener = useCallback((e) => {
    let key = e.key.toLowerCase();
    let ctrlKey = e.ctrlKey;
    if (ctrlKey && key === "s") {
      saveRef.current.click();
      return;
    }
  }, []);

  useEffect(() => {
    if (currentComponent === currentFocus?.id) return;
    if (!currentComponent || currentComponent === "default_focus") {
      if (currentFocus && document.getElementById(currentFocus.id)) {
        if (!currentFocus?.id?.startsWith("grid")) {
          setTimeout(() => {
            document
              .getElementById(currentFocus.id)
              .focus({ preventScroll: true });
          }, 150);
        } else {
          if (currentFocus?.id === "grid_stock_audit") {
            setTimeout(() => {
              focusCell(
                medicineGridRef?.current?.api,
                currentFocus.rowIndex,
                medicineGridRef?.current?.columnApi.getColumn(
                  currentFocus.column
                )
              );
            }, 150);
          }
        }
      } else {
        setTimeout(() => {
          default_focus.current?.focus();
        }, 150);
      }
    } else if (currentComponent === "grid_stock_audit") {
      if (medicineGridRef?.current?.api?.getSelectedNodes()?.length === 0) {
        medicineGridRef?.current?.focus(focusLastRow); //alston
        setTimeout(() => setFocusLastRow(true), 150);
      } else {
        medicineGridRef?.current?.focus(false); //alston
      }
    }
  }, [
    currentComponent,
    currentFocus,
    default_focus,
    focusLastRow,
    setFocusLastRow,
  ]);

  useEffect(() => {
    if (!autocompleteOpen) {
      document.addEventListener("keyup", stockAuditContextListener, false);
    }
    return () => {
      document.removeEventListener("keyup", stockAuditContextListener, false);
    };
  }, [autocompleteOpen, stockAuditContextListener]);

  return (
    <StockAuditContext.Provider
      value={{
        medicineGridRef,
        saveRef,
        saveAudit,
        setSaveAudit,
        showAuditorDetails,
        setShowAuditorDetails,
      }}
    >
      {children}
    </StockAuditContext.Provider>
  );
};
export default StockAuditContext;
